import * as React from "react";
import cn from "classnames";
import Styles from "./Title.module.scss";
import { OldRow } from "../OldGrid/OldRow";
import { Text } from "../Text/Text";

export interface TitleProps {
  text: string;
  children?: any;
  className?: string;
  testId?: string;
}

export const Title: React.FC<TitleProps> = ({ text, className, children, testId }) => (
  <OldRow padded={false} className={cn(Styles.row, className)} verticalAlign>
    <Text className={cn(Styles.text)} size={"xlarge"} weight={"xbold"} priority={1} data-testid={testId}>
      {text}
    </Text>
    {children}
  </OldRow>
);
